export interface IFactorWorkflowStepConfig {
  id?: number;
  stepNumber?: number;
  stepKey?: string;
  title?: string;
  requiredRole?: string;
  requiredRoleLabel?: string;
  slaDays?: number;
}

export const FACTOR_WORKFLOW_ROLE_OPTIONS = [
  { value: 'ROLE_FACTOR_WF_STEP_1', label: 'مرحله ۱ · ثبت درخواست مشتری' },
  { value: 'ROLE_FACTOR_WF_STEP_2', label: 'مرحله ۲ · انتصاب پیمانکار' },
  { value: 'ROLE_FACTOR_WF_STEP_3', label: 'مرحله ۳ · دریافت اندازه‌گیری و فاکتور نهایی از پیمانکار' },
  { value: 'ROLE_FACTOR_WF_STEP_4', label: 'مرحله ۴ · صدور فاکتور فروش' },
  { value: 'ROLE_FACTOR_WF_STEP_5', label: 'مرحله ۵ · تأیید تولید' },
  { value: 'ROLE_FACTOR_WF_STEP_6', label: 'مرحله ۶ · هماهنگی با پیمانکار برای تولید' },
  { value: 'ROLE_FACTOR_WF_STEP_7', label: 'مرحله ۷ · اجرا' },
  { value: 'ROLE_FACTOR_WF_STEP_8', label: 'مرحله ۸ · تحویل و تسویه' }
];
